export interface IConstants {
  id?: number;
  name?: string | null;
  value?: string | null;
}

export const defaultValue: Readonly<IConstants> = {};
